<script>
import DataLayer from '@services/data-layer/index'
import MixLargeTile from '@components/mix-large-tile'
import MixGridTile from '@components/mix-grid-tile'

export default {
    components: { MixLargeTile, MixGridTile },
    props: {
        nowPlaying: {
            type: Object,
            default: () => {},
        },
        channel: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            trendingMixes: [],
        }
    },
    computed: {
        trendingTitle() {
            return `Trending on ${this.channel?.title || ''}`.trim()
        },
        displayedMixes() {
            return this.trendingMixes.slice(0, 6)
        },
    },
    watch: {
        '$route.params.channelId'() {
            this.loadTrendingMixes()
        },
    },
    mounted() {
        this.loadTrendingMixes()
    },
    methods: {
        async loadTrendingMixes() {
            const response = await DataLayer.mixes.getPopularByChannel(this.$route.params.channelId)
            this.trendingMixes = response.body
        },
    },
}
</script>

<template>
    <BaseContent>
        <BaseSection
            padded
            title="Now Playing"
        >
            <MixLargeTile
                v-if="nowPlaying"
                :mix="nowPlaying.mixes"
                :channel="channel"
            >
                <BaseButtonPlay
                    slot="button"
                    :resource="channel"
                    type="secondary"
                />
            </MixLargeTile>
        </BaseSection>
        <BaseSection
            v-if="displayedMixes.length"
            :title="trendingTitle"
            padded
        >
            <carousel
                :per-page-custom="[[0, 2], [768, 3], [1025, 6]]"
                :pagination-enabled="false"
                :navigation-enabled="false"
                :scroll-per-page="false"
                :min-swipe-distance="100"
                :space-padding="0"
                :mouse-drag="displayedMixes.length > 1"
                class="carousel"
            >
                <slide
                    v-for="(mix, index) in displayedMixes"
                    :key="`channel-trending-${mix.id}-${index}`"
                    class="slide"
                >
                    <MixGridTile
                        :mix="mix"
                        :index="index"
                    />
                </slide>
            </carousel>
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.carousel {
    position: relative;
    margin: 0 (-$size-grid-padding);
    overflow: visible;
}

.slide {
    position: relative;
    padding: 0 $size-grid-padding;

    &:hover,
    &:focus-within {
        z-index: 2;
    }
}

:deep(.carousel .VueCarousel-wrapper),
:deep(.carousel .VueCarousel-inner),
:deep(.carousel .VueCarousel-slide) {
    overflow: visible;
}
</style>
